export default __webpack_public_path__ + "assets/images/aistudio/empty_state/0331a1c2d3af09801371b56b004b6627.png";